import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

function getLocationsToProcess() {
    let keys = [];
    for (let n = 0; n < localStorage.length; n++) {
        const thisKey = localStorage.key(n);
        if (thisKey.includes("offlineLocationToProcess")) {
            // found it
            keys.push(thisKey);
        }
    }
    let locations = [];
    for (let i = 0; i < keys.length; i++) {
        locations.push(JSON.parse(localStorage[keys[i]]));
    }
    return locations;
}

export default new Vuex.Store({
  state: {
      user: null,
      isLoading: false,
      token: Cookies.get('token'),
      showConfirmMessage: false,
      showForgotMessage: false,
      campaignsList: [],
      currentLocation: {},
      currentRespondent: {},
      currentRespondentOffline: {},
      currentCampaign: {},
      alerts: [],
      alertLastDate: Cookies.get('alertLastDate'),
      showTooltipAddMarker: true,
      offlineLocations: getLocationsToProcess(),
      online: navigator.onLine,
      isInstalledPWA: true,
      deferredPWA: null
  },
  mutations: {
    saveDeferredPWA(state, { deferredPWA }) {
        state.deferredPWA = deferredPWA;
    },
    saveIsInstalledPWA(state, { isInstalledPWA }) {
        state.isInstalledPWA = isInstalledPWA;
    }, 
    saveOnline (state, { online }) {
        state.online = online;
    },
    refreshOfflineLocations(state) {
        state.offlineLocations = getLocationsToProcess();
    },
    saveOfflineLocation (state, { offlineLocation }) {
        if (typeof offlineLocation.time_added_offline != 'undefined' && localStorage['offlineLocationToProcess'+ offlineLocation.time_added_offline]) {
            localStorage['offlineLocationToProcess'+ offlineLocation.time_added_offline] = JSON.stringify(offlineLocation);
        } else {
            let time = new Date().getTime();
            offlineLocation.time_added_offline = time;
            localStorage['offlineLocationToProcess' + time] = JSON.stringify(offlineLocation);
        }
        state.offlineLocations = getLocationsToProcess();
    },
    deleteOfflineLocation (state, { offlineLocation }) {
        if (typeof offlineLocation.time_added_offline != 'undefined' && localStorage['offlineLocationToProcess'+ offlineLocation.time_added_offline]) {
            localStorage.removeItem('offlineLocationToProcess'+ offlineLocation.time_added_offline);
        } 
        
        state.offlineLocations = getLocationsToProcess();
    },
    savetoken (state, { token, remember }) {
        state.token = token;
        Cookies.set('token', token, { expires: remember ? 365 : null });
    },
    saveAlertLastDate (state, { alertLastDate }) {
        state.alertLastDate = alertLastDate;
        Cookies.set('alertLastDate', alertLastDate, { expires: 365 });
    },

    saveUser (state, { user }) {
        state.user = user;
    },

    saveShowTooltipAddMarker (state, { showTooltipAddMarker }) {
        state.showTooltipAddMarker = showTooltipAddMarker;
    },

    saveAlerts (state, { alerts }) {
        state.alerts = alerts;
    },

    saveCurrentLocation (state, { currentLocation }) {
        state.currentLocation = currentLocation;
    },

    saveCurrentRespondent (state, { currentRespondent }) {
        state.currentRespondent = currentRespondent;
    },

    saveCurrentRespondentOffline (state, { currentRespondentOffline }) {
        state.currentRespondentOffline = currentRespondentOffline;
    },

    saveCurrentCampaign (state, { currentCampaign }) {
        state.currentCampaign = currentCampaign;
    },

    saveCampaignsList (state, { campaignsList }) {
        state.campaignsList = campaignsList;
    },

    addToTopOfCampaignsList (state, { campaign }) {
        state.campaignsList.unshift(campaign);
    },

    removeFromCampaignsList (state, { campaign }) {
        state.campaignsList = state.campaignsList.filter(function(camp) {
            return campaign._id != camp._id;
        });
    },

    saveIsLoading (state, { isLoading }) {
        state.isLoading = isLoading;
    },

    showConfirmMessage (state, { showConfirmMessage }) {
        state.showConfirmMessage = showConfirmMessage
    },

    showForgotMessage (state, { showForgotMessage }) {
        state.showForgotMessage = showForgotMessage
    },

    forceLogout (state) {
        state.user = null;
        state.token = null;
        state.campaignsList = [];
        state.showTooltipAddMarker = true;

        Cookies.remove('token')
    },
  },
  actions: {
        saveDeferredPWA ({ commit, dispatch }, payload) {
            commit('saveDeferredPWA', payload)
        },
        saveIsInstalledPWA ({ commit, dispatch }, payload) {
            commit('saveIsInstalledPWA', payload)
        },
        saveOnline ({ commit, dispatch }, payload) {
            commit('saveOnline', payload)
        },
        saveOfflineLocation ({ commit, dispatch }, payload) {
            commit('saveOfflineLocation', payload)
        },
        deleteOfflineLocation ({ commit, dispatch }, payload) {
            commit('deleteOfflineLocation', payload)
        },
        refreshOfflineLocations ({ commit, dispatch }) {
            commit('refreshOfflineLocations')
        },
        showForgotMessage ({ commit, dispatch }, payload) {
            commit('showForgotMessage', payload)
        },

        showConfirmMessage ({ commit, dispatch }, payload) {
            commit('showConfirmMessage', payload)
        },

        saveToken ({ commit, dispatch }, payload) {
            commit('savetoken', payload)
        },
        saveAlertLastDate ({ commit, dispatch }, payload) {
            commit('saveAlertLastDate', payload)
        },

        saveCampaignsList ({ commit, dispatch }, payload) {
            commit('saveCampaignsList', payload)
        },

        saveShowTooltipAddMarker ({ commit, dispatch }, payload) {
            commit('saveShowTooltipAddMarker', payload)
        },

        saveAlerts ({ commit, dispatch }, payload) {
            commit('saveAlerts', payload)
        },

        addToTopOfCampaignsList ({ commit, dispatch }, payload) {
            commit('addToTopOfCampaignsList', payload)
        },

        removeFromCampaignsList ({ commit, dispatch }, payload) {
            commit('removeFromCampaignsList', payload)
        },

        saveUser ({ commit, dispatch }, payload) {
            commit('saveUser', payload)
        },

        saveCurrentLocation ({ commit, dispatch }, payload) {
            commit('saveCurrentLocation', payload)
        },

        saveCurrentRespondent ({ commit, dispatch }, payload) {
            commit('saveCurrentRespondent', payload)
        },

        saveCurrentRespondentOffline ({ commit, dispatch }, payload) {
            commit('saveCurrentRespondentOffline', payload)
        },

        saveCurrentCampaign ({ commit, dispatch }, payload) {
            commit('saveCurrentCampaign', payload)
        },

        saveIsLoading ({ commit, dispatch }, payload) {
            commit('saveIsLoading', payload)
        },

        forceLogout ({ commit, dispatch }) {
            commit('forceLogout')
        },
  },
  getters: {
    deferredPWA: state => state.deferredPWA,
    isInstalledPWA: state => state.isInstalledPWA,
    online: state => state.online,
    user: state => state.user,
    offlineLocations: state => state.offlineLocations,
    campaignsList: state => state.campaignsList,
    token: state => state.token,
    isLoading: state => state.isLoading,
    showConfirmMessage: state => state.showConfirmMessage,
    showForgotMessage: state => state.showForgotMessage,
    currentLocation: state => state.currentLocation,
    currentRespondent: state => state.currentRespondent,
    currentRespondentOffline: state => state.currentRespondentOffline,
    currentCampaign: state => state.currentCampaign,
    alerts: state => state.alerts,
    alertLastDate: state => state.alertLastDate,
    showTooltipAddMarker: state => state.showTooltipAddMarker,
  }
});
